export const API_BASE_URL = process.env.REACT_APP_API_URL;
//Ubicaciones de las secciones validas
export const UBICACIONES_SECCIONES_VALIDAS = Object.freeze({
  NAVBAR: 'navbar',
  FOOTER: 'footer',
});
//ELIMINAR / MOVER A .ENV
export const CLOUDINARY_API_KEY = process.env.REACT_APP_CLOUDINARY_API_KEY;
export const CLOUDINARY_CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
